import React from 'react'
import { translate } from 'react-i18next'
import { Link, withRouter } from 'react-router-dom'
import AudioSimpleControls from '../AudioSimpleControls'
import SimpleBtn from '../SimpleBtn'
import './index.sass'

const VoiceItem = ({
  voiceItem,
  toggleFavoriteVoice,
  changeModalVisibility,
  t,
  currentPlayingVoice,
  setPlayingStatus,
  toggleVisibleAudioPlayer,
  setPlayingVoiceId,
  setChoosenVoice,
  hasVoiceSescr,
  match,
}) => {
  const base = match.url.charAt(match.url.length - 1) === '/' ? match.url.slice(0, -1) : match.url
  return (
    <div className="voice-item">
      <header>
        <AudioSimpleControls
          toggleFavoriteVoice={toggleFavoriteVoice}
          voiceItem={voiceItem}
          isAudioPlaying={
            voiceItem.id === currentPlayingVoice.currentVoiceId &&
            currentPlayingVoice.isAudioPlaying
          }
          toggleVisibleAudioPlayer={toggleVisibleAudioPlayer}
          setPlayingStatus={setPlayingStatus}
          setPlayingVoiceId={setPlayingVoiceId}
        />
      </header>
      <div className="text-wrapper">
        <p className="body-light">
          {t('general.Language')}:{''}
          {hasVoiceSescr ? (
            <Link
              to={`${base}/${voiceItem.language.toLowerCase().split(' ').join('-')}`}
            >
              {t(`Language.${voiceItem.language}`)}
            </Link>
          ) : (
            <span className="subtitle-2">{t(`Language.${voiceItem.language}`)}</span>
          )}
        </p>
        <p className="body-light">
          {t('general.Gender')}:{' '}
          <span className="subtitle-2">{t(`filter.${voiceItem.gender}`)}</span>
        </p>
        <p className="body-light">
          {t('general.Age')}: <span className="subtitle-2">{t(`filter.${voiceItem.age}`)}</span>
        </p>
      </div>

      <SimpleBtn
        btnName={t('general.order voice')}
        onHandleClick={() => {
          changeModalVisibility(true)
          setPlayingStatus(false)
          toggleVisibleAudioPlayer(false)
          setChoosenVoice(voiceItem.id)
        }}
      />
    </div>
  )
}

export default withRouter(translate('translations')(VoiceItem))
